import {ExpandedGroupIds} from '@hconnect/common/hooks/useExpandGroups'
import {EquipmentPerformance, KpiCalculationTimeFrameDto} from '@hconnect/common/types'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {KeyboardArrowRight, KeyboardArrowDown} from '@mui/icons-material'
import {Box, Typography, IconButton, SxProps, Theme} from '@mui/material'
import React from 'react'

import {EquipmentKpiAssignment} from './EquipmentKpiAssignment'

type Props = {
  data: EquipmentPerformance[]
  timeFrames: KpiCalculationTimeFrameDto[]
  cardBoxSx?: SxProps<Theme>
  expandedEquipments: string[]
  toggleExpandedEquipments: (id: ExpandedGroupIds) => void
}

export const EquipmentKpiCardsOverview = ({
  data,
  timeFrames,
  cardBoxSx,
  expandedEquipments,
  toggleExpandedEquipments
}: Props) => {
  return (
    <Box data-test-id="equipment-kpi-cards-overview">
      {data.map((equipmentPerformance, index) => {
        const isExpanded = expandedEquipments.includes(index.toString())
        return (
          <CardBox sx={cardBoxSx} key={`equipment-kpi-card-${equipmentPerformance.equipment.id}`}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                pt: 1.5,
                pb: 1.5
              }}
            >
              <IconButton size="small" onClick={() => toggleExpandedEquipments(index.toString())}>
                {isExpanded ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
              </IconButton>

              <Typography variant="h3">{equipmentPerformance.equipment.text}</Typography>
            </Box>
            {isExpanded &&
              equipmentPerformance.kpiPerformance?.kpiAssignments?.map((kpiAssignment) => (
                <EquipmentKpiAssignment
                  key={`equipment-kpi-card-assignments-${kpiAssignment.kpiName}`}
                  kpiAssignment={kpiAssignment}
                  timeFrames={timeFrames}
                />
              ))}
          </CardBox>
        )
      })}
    </Box>
  )
}
